export default "__VITE_ASSET__2zZwOdMU__"